import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from "rxjs";
import { filter, map, take, tap } from "rxjs/operators";
import { get, isEmpty } from "lodash";
import { Widget } from "@ispm-client/modules/widgets/decorator/widget.decorator";
import { IWidgetItem } from "@ispm-client/modules/widgets/interfaces/widget-item.interface";
import { IBrandData } from "../../models";
import { BrandsService } from "../../services";

@Component({
  selector: 'gen-brand-preview',
  templateUrl: './brand-preview.component.html',
  styleUrls: ['./brand-preview.component.scss']
})
@Widget('BrandPreview')
export class BrandPreviewComponent implements IWidgetItem, OnChanges {
  @Input() public chosenBrand: string;
  @Input() public inForm = false;

  public chosenBrandDetails$: Observable<IBrandData>;

  widgetData:any;

  constructor(private brandsService: BrandsService, private domSanitizer: DomSanitizer) {    
  }

  ngOnChanges(changes: SimpleChanges): void {
    const chosenBrandId = get(changes, 'chosenBrand.currentValue', undefined);
    if (chosenBrandId) {
      this.chosenBrandDetails$ = this.brandsService.getBrand(chosenBrandId).pipe(
        filter(brand => !!brand),
        take(1),
        map(brandDetails => (<IBrandData>{...brandDetails, logo: isEmpty(brandDetails.logo) ? undefined : this.domSanitizer.bypassSecurityTrustUrl(brandDetails.logo)})));
    }
  }
}
